import styled from 'styled-components';
import { theme } from 'styles';

export const Container = styled.div`
  display: flex;
  position: relative;
  width: ${({ $count, $line }) => ($line ? $count * 62 + 6 : $count * 80 + 6)}px;
  height: 30px;
  padding: 1px 2px;
  border: 1px solid ${({ $disabled }) => ($disabled ? theme.colors.fill05 : theme.colors.gray100)};
  background-color: ${({ $disabled }) => ($disabled ? theme.colors.fill02 : theme.colors.gray50)};
  border-radius: 20px;
  overflow: hidden;
`;

export const Slider = styled.div`
  position: absolute;
  top: 1px;
  width: ${({ $line }) => ($line ? '62px' : '80px')};
  height: 26px;
  left: ${({ $index, $line }) => ($line ? $index * 62 + 2 : $index * 80 + 2)}px;
  ${({ $line, $disabled }) =>
    $disabled
      ? `
        background-color: transparent; 
        border: 1px solid transparent; 
      `
      : $line
        ? `background-color: ${theme.colors.primary50}; border: 1px solid ${theme.colors.primary}`
        : `background-color: ${theme.colors.primary800}`};
  border-radius: 15px;
  transition: left 0.3s ease;
  z-index: 1;
`;

export const Label = styled.label`
  min-width: ${({ $line }) => ($line ? '62px' : '80px')};
  max-width: ${({ $line }) => ($line ? '62px' : '80px')};
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
  cursor: pointer;
  border-radius: 15px;
  color: ${({ $active, $line, $disabled }) =>
    $disabled
      ? theme.colors.fill05
      : $active && $line
        ? theme.colors.primary
        : $active && !$line
          ? '#ffffff'
          : theme.colors.assistive};
  position: relative;
  font-size: 14px;
  line-height: 1;
  transition:
    color 0.3s ease,
    font-size 0.3s ease;

  ${({ $disabled }) =>
    !$disabled &&
    `
    &:hover {
      background-color: ${theme.colors.fill02};
    }
  `}

  input {
    display: none;
  }
`;
